import { Link2Off } from 'lucide-react';

import { ErrorPage } from '@/modules/errors/components/ErrorPage';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';

export function ShortlistInvalidLink() {
  return (
    <div className="bg-neutral-120 min-h-screen px-4 py-12">
      <ErrorPage
        icon={<Link2Off className="text-neutral-650 size-16" aria-hidden />}
        title="This shortlist link isn't valid"
        message={
          <Paragraph className="mx-auto max-w-md text-pretty">
            The link may be incomplete or expired. Ask your Finlay contact to
            send an updated shortlist link.
          </Paragraph>
        }
      />
    </div>
  );
}
